module.exports = __webpack_public_path__ + "static/img/John-Pappajohn-Entrepreneurial-Center-LockupHorizontal-BLACK.ee81c267.png";